const STORAGE_KEY = 'avs_connect_cookie_consent_v1';

/** @typedef {{ version: number, choice: 'all' | 'essential', decidedAt: string }} CookieConsentRecord */

/**
 * @returns {CookieConsentRecord | null}
 */
export function getCookieConsent() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && (parsed.choice === 'all' || parsed.choice === 'essential')) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function hasAnsweredCookieConsent() {
  return getCookieConsent() !== null;
}

/**
 * @param {'all' | 'essential'} choice
 */
export function setCookieConsent(choice) {
  const record = {
    version: 1,
    choice,
    decidedAt: new Date().toISOString(),
  };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  window.dispatchEvent(new CustomEvent('avs-cookie-consent-changed', { detail: record }));
}

/** Use before loading non-essential analytics/marketing scripts. */
export function allowsOptionalCookies() {
  const c = getCookieConsent();
  return c?.choice === 'all';
}
